export const USER_NEWSLETTER_SUBSCRIBTION_SUCCESS = 'USER_NEWSLETTER_SUBSCRIBTION_SUCCESS'
